import React, { useEffect, useRef } from "react";
import styled from "styled-components";
import Support from "../SupportOptions";
import { useModal } from "./ModalContext";
import useOnClickOutside from "../../hooks/useOnClickOutside";


const Modal = () => {

  const { modalVisibility, toggleModalVisibility, showModal, hideModal } = useModal();

  const cookie = function( name, value, days ){
    // if value is undefined, get the cookie value
    if( value === undefined ){
        var cookiestring = "; " + window.document.cookie;
        var cookies = cookiestring.split( "; " + name + "=" );
        if ( cookies.length === 2 ){
            return cookies.pop().split( ";" ).shift();
        }
        return null;
    }
    else {
        // if value is a false boolean, we'll treat that as a delete
        if( value === false ){
            days = -1;
        }
        var expires = "";
        if ( days ) {
            var date = new Date();
            date.setTime( date.getTime() + ( days * 24 * 60 * 60 * 1000 ) );
            expires = "; expires="+date.toGMTString();
        }
        window.document.cookie = name + "=" + value + expires + "; path=/";
    }
  }

  useEffect(() => {
    
    const modalTimeout = setTimeout(() => {
      if ( cookie( "hide_popup" ) == null ) {
        showModal();
      }
    }, 30000)

    return () => clearTimeout(modalTimeout)

  }, []);

  const handleHideModal = () => {
    cookie( "hide_popup", "true", 3 )
    toggleModalVisibility()
  };

  useEffect(() => {
    console.log(modalVisibility)
  }, [modalVisibility]);

  const modalRef = useRef(undefined);
  useOnClickOutside(modalRef, hideModal);
  
  return (
    <StyledModal ref={modalRef} className={modalVisibility ? "is-visible" : undefined}>
      <StyledModalClose
        onClick={() => handleHideModal()}
      >Close</StyledModalClose>
      <Support inline />
    </StyledModal>
  )
}

export default Modal;


const StyledModal = styled.aside`
  position: fixed;
  z-index: 110;
  right: 0;
  top: calc(100% + 6em);
  left: 0;
  background-color: var(--theme-background-light);
  color: var(--theme-text-against-light);
  padding: 0 var(--gutter);
  transition: transform 0.6s var(--bezier);
  transform: translate3d(0,0,0);
  &.is-visible {
    transform: translate3d(0,calc(-100% - 6em),0);
  }
`;
export { StyledModal };

const StyledModalClose = styled.button`
  position: absolute;
  top: 1.25em;
  right: 1.25em;
  border-radius: 0;
  height: 1.5em;
  width: 1.5em;
  padding: 0;
  font-size: 1em;
  text-indent: -9999em;
  overflow: hidden;
  color: inherit;
  transition: opacity 0.3s ease;
  z-index: 5;
  cursor: pointer;
  &::before,
  &::after {
    content: '';
    position: absolute;
    top: calc(50% - 0.0625em);
    left: 0.5em;
    width: 1em;
    height: 0.125em;
    background-color: currentColor;
  }
  &::before {
    transform: rotate(-45deg);
  }
  &::after {
    transform: rotate(45deg);
  }
  .can-hover &:hover,
  &:active {
    opacity: 0.5;
  }

`